import React from "react";
import Grid from "@mui/material/Grid2";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import FallbackTypography from "src/components/shared/FallbackTypography";
import { ReservationType } from "src/utils/common";

const VoucherTableContainer = ({ allItems }) => {
  const getItemName = (item) => {
    return item?.type === ReservationType.hotel ? item?.RoomName : item?.UnitName;
  };

  const getItemType = (item) => {
    return item?.type === ReservationType.hotel ? item?.RoomType : item?.UnitType;
  };

  const getItemCount = (item) => {
    return item?.type === ReservationType.hotel ? item?.NumberOfRooms : item?.NumberOfUnits;
  };

  const hasHotelItems = allItems.some(item => item?.type === ReservationType.hotel);

  return (
    <Grid container pt={3} justifyContent="center">
      <Paper variant="outlined">
        <TableContainer sx={{ overflow: "auto" }}>
          <Table sx={{ whiteSpace: "nowrap" }}>
            <TableHead>
              <TableRow>
                <TableCell width={"210px"}>
                  <Typography>
                    {hasHotelItems ? 'Room Name' : 'Service Name'}
                  </Typography>
                </TableCell>
                {hasHotelItems && (
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight={600}>
                      No. Nights
                    </Typography>
                  </TableCell>
                )}
                <TableCell width={"210px"}>
                  <Typography>
                    {hasHotelItems ? 'Room Type' : 'Unit Type'}
                  </Typography>
                </TableCell>
                <TableCell width={"210px"}>
                  <Typography>
                    {hasHotelItems ? 'No. Rooms' : 'No. Units'}
                  </Typography>
                </TableCell>
                <TableCell width={"460px"}>
                  <Typography>Supplements and Discounts</Typography>
                </TableCell>
                <TableCell width={"190px"}>
                  <Typography>No. Pax</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {allItems.map((item, index) => (
                <TableRow key={`item-${index}`}>
                  <TableCell>
                    <FallbackTypography value={getItemName(item)} />
                  </TableCell>
                  {hasHotelItems && (
                    <TableCell>
                      <FallbackTypography value={item?.NumberOfNights} />
                    </TableCell>
                  )}
                  <TableCell>
                    <FallbackTypography value={getItemType(item)} />
                  </TableCell>
                  <TableCell>
                    <FallbackTypography value={getItemCount(item)} />
                  </TableCell>
                  <TableCell>
                    {item?.Supplements?.length > 0 && (
                      <FallbackTypography value={`Supplements: ${item.Supplements.join(", ")}`} />
                    )}
                    {item?.Discounts?.length > 0 && (
                      <FallbackTypography value={`Discounts: ${item.Discounts.join(", ")}`} />
                    )}
                    {!item?.Supplements?.length && !item?.Discounts?.length && (
                      <Typography>None</Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    <FallbackTypography value={item?.PaxCount} />
                  </TableCell>
                </TableRow>
              ))}
              {allItems.length === 0 && (
                <TableRow>
                  <TableCell colSpan={hasHotelItems ? 6 : 5} align="center">
                    <Typography>No data available</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Grid>
  );
};

export default VoucherTableContainer;